import { cloneElement, useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Apartment from "@mui/icons-material/Apartment";

import Activity from "components/DigiHapi/Activity";
import Notification from "components/DigiHapi/Notification";
import CommunityInfoCard from "components/DigiHapi/CommunityInfoCard";

import { MdLocationCity } from "react-icons/md";
import { GiCampingTent } from "react-icons/gi";
import { GrOrganization } from "react-icons/gr";

import { fetchGetCurrentCommunityDetails } from "actions/community";
import { fetchGetCityDetails } from "actions/city";
import { fetchGetCampsiteDetails } from "actions/campsite";
import { fetchGetNeighborhoodDetails } from "actions/neighborhood";
import { fetchGetOrganizationDetails } from "actions/organization";

// Redux
import { useDispatch, useSelector } from "react-redux";

import {
	TYPE_CITY,
	TYPE_NEIGHBORHOOD,
	RESET_CAMPSITE,
	RESET_NEIGHBORHOOD,
	RESET_CITY,
	ROLE_ADMINISTRATOR,
	ROLE_WEBMASTER,
	TYPE_ORGANIZATION,
	RESET_ORGANIZATION,
	ROLE_EMPLOYEE
} from "actions/types";
import Cities from "./Cities/CitiesPage";
import Campsites from "./Campsites/CampsitesPage";
import Neighborhoods from "./Neighborhoods/NeighborhoodsPage";
import Organizations from "./Organizations/OrganizationsPage";

const { REACT_APP_DEEPLINK_URL = "https://app.hapicolibri.digihapi.com" } =
	process.env;

export default function CommunityPage(props) {
	const dispatch = useDispatch();

	const { community } = useSelector(state => state.entitiesReducer);

	const { user } = useSelector(state => state.profileReducer);

	let icon, resetType, component, reducer;

	switch (community.communitytype) {
		case TYPE_ORGANIZATION:
			icon = <GrOrganization />;
			resetType = RESET_ORGANIZATION;
			component = <Organizations.OrganizationsWizard />;
			reducer = "organizationReducer";
			break;
		case TYPE_CITY:
			icon = <MdLocationCity />;
			resetType = RESET_CITY;
			component = <Cities.CitiesWizard />;
			reducer = "cityReducer";
			break;
		case TYPE_NEIGHBORHOOD:
			icon = <Apartment />;
			resetType = RESET_NEIGHBORHOOD;
			component = <Neighborhoods.NeihborhoodsWizard />;
			reducer = "neighborhoodReducer";
			break;
		default:
			icon = <GiCampingTent />;
			resetType = RESET_CAMPSITE;
			component = <Campsites.CampsitesWizard />;
			reducer = "campsiteReducer";
			break;
	}

	const { isFetching, newWizard, snackInfoMsg, snackErrorMsg } = useSelector(
		state => state[reducer]
	);

	const [br, setBr] = useState(false);
	const [message, setMessage] = useState(null);
	const [color, setColor] = useState("info");
	const [wizard, setWizard] = useState(null);

	const fetchGetCommunityDetails = () => {
		switch (community.communitytype) {
			case TYPE_ORGANIZATION:
				dispatch(fetchGetOrganizationDetails(community._id));
				break;
			case TYPE_CITY:
				dispatch(fetchGetCityDetails(community._id));
				break;
			case TYPE_NEIGHBORHOOD:
				dispatch(fetchGetNeighborhoodDetails(community._id));
				break;
			default:
				dispatch(fetchGetCampsiteDetails(community._id));
				break;
		}
	};

	useEffect(() => {
		if (snackInfoMsg || snackErrorMsg) {
			if (snackInfoMsg) {
				setWizard(null);
				dispatch(fetchGetCurrentCommunityDetails());
			}
			setBr(true);
			setMessage(snackInfoMsg ? snackInfoMsg : snackErrorMsg);
			setColor(snackInfoMsg ? "info" : "danger");
			if (snackInfoMsg) {
				setTimeout(() => setBr(false), 5000);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [snackInfoMsg, snackErrorMsg]);

	const onClose = () => {
		setWizard(null);
		dispatch({
			type: resetType
		});
	};

	useEffect(() => {
		if (newWizard) {
			const wizard = cloneElement(component, { update: true, onClose }, null);
			setWizard(wizard);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [newWizard]);

	const {
		logoUri,
		name,
		phone,
		mail,
		webSiteUrl,
		qrcodeUri,
		address,
		zipCode,
		city
	} = community;

	const canSeeLinks =
		user.role === ROLE_ADMINISTRATOR ||
		user.role === ROLE_EMPLOYEE ||
		user.role === ROLE_WEBMASTER;
	const actions = [
		canSeeLinks &&
			community.customUri && {
				tooltip: "Ouvrir sur mobile",
				icon: "mobile_screen_share",
				color: "warning",
				href: `${REACT_APP_DEEPLINK_URL}/${community.customUri}/actualites`
			},
		canSeeLinks &&
			community.pdfUri && {
				tooltip: "Ouvrir le PDF d'accueil",
				icon: "picture_as_pdf",
				color: "primary",
				href: community.pdfUri
			},
		(user.role === ROLE_ADMINISTRATOR || user.role === ROLE_WEBMASTER) && {
			tooltip: "Modifier",
			icon: "edit",
			color: "info",
			disabled: wizard !== null,
			onClick: fetchGetCommunityDetails
		}
	].filter(Boolean);

	return (
		<Grid container spacing={3}>
			<Grid item xs={12} sm={6} lg={4}>
				{isFetching ? (
					<Activity />
				) : (
					<CommunityInfoCard
						logoUri={logoUri}
						icon={icon}
						name={name}
						qrcodeUri={qrcodeUri}
						actions={actions}
						address={address}
						zipCode={zipCode}
						city={city}
						phone={phone}
						mail={mail}
						webSiteUrl={webSiteUrl}
					/>
				)}
			</Grid>
			{wizard && (
				<Grid item xs={12}>
					{wizard}
				</Grid>
			)}
			<Notification
				place="br"
				color={color}
				message={message}
				open={br}
				onClose={() => setBr(false)}
			/>
		</Grid>
	);
}
